import WebApp from "@twa-dev/sdk";
import axios from "axios";
import { API_URL } from "../config";

export const generateInviteLink = async (channelId, userId, APIKey) => {
  const response = await axios.get(
    `${API_URL}/api/channel/${channelId}/createPaidInviteLink/${userId}`,
    {
      params: { initData: WebApp.initData },
      headers: { "x-api-key": APIKey },
    }
  );
  return response.data.inviteLink;
};

export const updateUserLinks = async (
  inviteLink,
  setUserData,
  userId,
  APIKey,
  channelName = "Channel"
) => {
  setUserData((prev) => {
    const newLinkObj = {
      name: channelName,
      link: inviteLink,
      channelName: channelName,
      createdAt: new Date().toISOString()
    };
    const updatedLinks = [...(prev.user?.links || []), newLinkObj];
    return {
      ...prev,
      user: {
        ...prev.user,
        links: updatedLinks,
      },
    };
  });
  const updatedUserResponse = await axios.get(`${API_URL}/api/user/${userId}`, {
    params: { initData: WebApp.initData },
    headers: { "x-api-key": APIKey },
  });
  if (updatedUserResponse.data) {
    setUserData((prev) => ({
      ...prev,
      user: updatedUserResponse.data,
    }));
  }
};